import { Button, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import clsx from 'clsx';
import React, { useState } from 'react';
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { MEETING_STATUS } from '../../base/app/constants';
import { guestOut } from '../../base/conference/functions';
import Image from '../../base/react/components/web/Image';
import Watermarks from '../../base/react/components/web/Watermarks';
import { withPixelLineHeight } from '../../base/styles/functions.web';
import { TOTAL_HEADER_FEEDBACK_HEIGHT } from '../../base/ui/constants.any';
import { BANNER_FEEDBACK } from '../../recording/components/Recording/styles.web';
import RenderRating from './RenderRating';
import { homePage } from '../../base/util/functions';
import useBrowser from '../../base/util/useBrowser';
import { toastSuccess } from '../../notifications/components/web/Toastify';
import { browser } from '../../base/lib-jitsi-meet';
import { refreshTokenWrapper } from '../../api/axiosClient';
import apiManagerWB from '../../api/apiManagerWB';
import moment from 'moment';
import { authDomain } from '../../../../modules/API/constants_ts';
const IconSubmited = () => (React.createElement("svg", { width: "57", height: "57", viewBox: "0 0 57 57", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M28.5 57C44.2401 57 57 44.2401 57 28.5C57 12.7599 44.2401 0 28.5 0C12.7599 0 0 12.7599 0 28.5C0 44.2401 12.7599 57 28.5 57Z", fill: "#00AB76" }),
    React.createElement("path", { d: "M48.9137 22.3349L32.5097 38.739L24.8544 46.3942L17.1992 38.739L24.8544 31.0837L41.2585 14.6797L48.9137 22.3349Z", fill: "white" }),
    React.createElement("path", { d: "M32.5096 38.7403L24.8544 46.3955L8.64917 30.1572L16.2712 22.502L24.8544 31.0851L32.5096 38.7403Z", fill: "white" })));
const rateValueTextNew = [
    "Rất tệ",
    "Tệ",
    "Bình thường",
    "Tuyệt",
    "Rất tuyệt"
];
const minuteSeconds = 30;
const timerProps = {
    isPlaying: true,
    size: 40,
    strokeWidth: 4,
};
const renderTime = (time) => {
    return (React.createElement("div", { className: "time-wrapper" },
        React.createElement("div", { className: "time" }, time)));
};
const getTimeSeconds = (time) => (minuteSeconds - time) | 0;
const useStyles = makeStyles()(theme => {
    return {
        feedbackPage: {
            color: theme.palette.default00,
            '& .details-container': {
                top: 0,
                left: 0,
                right: 0,
                height: TOTAL_HEADER_FEEDBACK_HEIGHT,
                backgroundColor: '#fff',
                boxShadow: '0px 5px 10px 0px rgba(0, 0, 0, 0.1)',
                width: 'unset',
                '& a.leftwatermark': {
                    left: '20px',
                    top: '19px'
                },
                '& div.leftwatermark': {
                    width: '120px',
                    height: '50px'
                },
                '& #count-down-timer': {
                    right: '24px',
                    left: 'unset !important',
                    top: '24px !important'
                }
            }
        },
        mainFeedbackContainer: {
            display: 'flex',
            paddingTop: '20px',
            flexDirection: 'column',
            rowGap: '100px',
            height: 'calc(100vh - 88px - 20px)',
            overflowY: 'auto',
            width: '100%',
            '&.submited': {
                rowGap: 'unset !important',
                columnGap: 'unset !important'
            },
            '& #rejoin-btn': {
                marginBottom: '16px'
            },
            '@media (min-width: 600px)': {
                '& #rejoin-btn': {
                    marginRight: '16px',
                    marginBottom: 'unset'
                }
            },
            '@media (min-width: 1024px)': {
                flexDirection: 'row',
                columnGap: '100px',
                rowGap: 'unset',
                justifyContent: 'center'
            },
            '@media (min-width: 1536px)': {
                flexDirection: 'row',
                columnGap: '200px',
                rowGap: 'unset',
                alignItems: 'center'
            }
        },
        bannerFeedback: {
            maxWidth: '693px',
            height: 'fit-content',
            alignSelf: 'center',
            width: '60%',
            '@media (min-width: 600px)': {
                width: '40%'
            },
            '@media (min-width: 1024px)': {
                alignSelf: 'start',
                marginTop: '54px'
            },
            '@media (min-width: 1536px)': {
                alignSelf: 'center',
            }
        },
        renderSubmit: {
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            paddingTop: '40px',
            alignItems: 'center',
            '& p': {
                paddingBottom: '12px',
                whiteSpace: 'pre-line',
                textAlign: 'center'
            }
        },
        mainTitle: {
            fontSize: '28px',
            textAlign: 'center',
            fontWeight: 600,
            // fontFamily: 'FSPFBeauSansPro'
        },
        boxActions: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            marginTop: '36px',
            marginBottom: '46px',
            '@media (min-width: 600px)': {
                flexDirection: 'row',
                rowGap: 0
            }
        },
        feedbackUser: {
            boxShadow: `0 8px 32px -4px rgb(12, 12, 13, 0.1)`,
            backgroundColor: '#f6f6f6',
            padding: '20px',
            width: 'calc(100vw - 60px)',
            margin: 'auto',
            borderRadius: '10px',
            '@media (min-width: 600px)': {
                width: '60%'
            },
            '@media (min-width: 1024px)': {
                width: '368px'
            },
            '@media (min-width: 1536px)': {
                padding: '36px',
            },
            '& .title-feedback': {
                // paddingTop: `min(max(4vh, 12px), 40px)`,
                fontSize: '24px',
                fontWeight: 700,
                textAlign: 'center'
            },
            '& .box-reactions': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                padding: '23px 0 36px 0',
                '@media (max-width: 300px)': {
                    alignItems: 'center'
                }
            }
        },
        dialogContent: {
            width: '100%',
            padding: 0,
            '@media (min-width: 1536px)': {
                width: '368px'
            }
        },
        feedbackLabel: {
            paddingTop: '28px',
            paddingBottom: '12px',
            ...withPixelLineHeight(theme.typography.bodyLongBoldLarge)
        },
        feedbackContent: {
            width: '100%',
            borderRadius: '6px',
            borderColor: theme.palette.default01,
            padding: '16px 20px',
            resize: 'vertical',
            maxHeight: '300px',
            height: '132px',
            '&:hover': {
                borderColor: theme.palette?.borderHover
            },
            '&:focus': {
                borderWidth: '1px',
                borderColor: theme.palette?.borderHover
            }
        },
        countdownLabel: {
            fontSize: '18px',
            fontWeight: 600,
            display: 'none',
            '@media (min-width: 600px)': {
                display: 'block'
            }
        }
    };
});
const FeedbackPage = () => {
    const { classes, cx } = useStyles();
    const { isTabActive } = useBrowser();
    const { local } = useSelector((state) => state['features/base/participants']);
    const { isShowFeedback } = useSelector((state) => state['features/feedback']);
    const { isOwnerCaption } = useSelector((state) => state['features/live-caption']);
    const { roomInfo } = useSelector((state) => state['features/base/conference']);
    const [feedbackValue, setFeedbackValue] = useState('');
    const [isSubmited, setIsSubmited] = useState(false);
    const [isEdited, setIsEdited] = useState(false);
    const [rateValueNew, setRateValueNew] = useState(0);
    const { t } = useTranslation();
    const handleForDesktopApp = async () => {
        try {
            if (browser?.isElectron()) {
                try {
                    await refreshTokenWrapper();
                    APP.API.notifyReadyToClose();
                }
                catch (error) {
                    console.error('error: ', error);
                }
            }
            else {
                homePage(true);
            }
        }
        catch (error) {
            console.log('err', error);
        }
    };
    const handleDetailCaption = async () => {
        try {
            let _filter = {
                startDate: moment().startOf('day').subtract(30, 'days').unix(),
                endDate: moment().endOf('day').unix(),
                is_moved_to_trash: 0,
                is_my: 1,
                is_share_with_me: 1,
                room_name: roomInfo?.roomId,
                page: 1
            };
            const res = await apiManagerWB.getListSub(_filter);
            if (res && res?.records) {
                const record = res.records.find((r) => r?.room_id === roomInfo?.roomId);
                window.location.href = record ? `${authDomain}/live-captions/detail?roomId=${roomInfo?.roomId}&live_captions_id=${record?.id}` : `${authDomain}/live-captions`;
            }
        }
        catch (error) {
            console.log('err', error);
        }
    };
    const handleTimeFish = () => {
        guestOut();
        handleForDesktopApp();
    };
    const handleActions = () => {
        setIsSubmited(true);
        toastSuccess({
            title: t('feedbackMeet.toast.title'),
            content: t('feedbackMeet.toast.content', { appName: interfaceConfig.APP_NAME || "Viettel Meeting" })
        });
        // fetch(`https://docs.google.com/forms/d/e/1FAIpQLScFLGgg1tbL2eK68iIvHZYVJmDC_sh87yZTlbNNNBBdsKt8Qw/formResponse?&submit=Submit?usp=pp_url&entry.1391775835=${rateValueText[rateValue]}&entry.1643861031=${feedbackValue}`)
        // https://docs.google.com/forms/d/e/1FAIpQLScFLGgg1tbL2eK68iIvHZYVJmDC_sh87yZTlbNNNBBdsKt8Qw/viewform?usp=pp_url&entry.1499495850=dev@gmail.com&entry.528321291=tuan+anh&entry.1391775835=Kh%C3%B4ng+h%C3%A0i+l%C3%B2ng+%F0%9F%99%81&entry.1643861031=hihiiii
        try {
            let formData = new FormData();
            formData.append('entry.1391775835', rateValueTextNew[rateValueNew - 1 || 0]);
            formData.append('entry.1643861031', feedbackValue);
            formData.append('entry.1499495850', local?.email || '');
            formData.append('entry.528321291', local?.name || '');
            fetch(`https://docs.google.com/forms/d/e/1FAIpQLScFLGgg1tbL2eK68iIvHZYVJmDC_sh87yZTlbNNNBBdsKt8Qw/formResponse`, {
                method: 'POST',
                body: formData
            });
        }
        catch (error) {
            console.log('[Error] ', error);
        }
        setTimeout(() => {
            handleTimeFish();
        }, 3000);
    };
    const handleChangeRateValue = (value) => {
        if (!isEdited)
            setIsEdited(true);
        setRateValueNew(value);
    };
    const RenderSubmited = () => {
        return (React.createElement("div", { className: cx(classes.renderSubmit) },
            React.createElement(IconSubmited, null),
            React.createElement("p", null, t("feedbackMeet.thanks", { appName: interfaceConfig.APP_NAME || "Viettel Meeting" }))));
    };
    return (React.createElement("div", { id: 'feedback-page', className: cx(classes.feedbackPage) },
        React.createElement("div", { className: 'details-container' },
            React.createElement(Watermarks, { hasColor: true }),
            !isEdited && React.createElement("div", { id: 'count-down-timer' },
                React.createElement(CountdownCircleTimer, { ...timerProps, colors: "#E43E65", duration: minuteSeconds, onComplete: handleTimeFish, isPlaying: isTabActive }, ({ elapsedTime, color }) => (React.createElement("span", { style: { color } }, renderTime(getTimeSeconds(elapsedTime))))),
                React.createElement("p", { className: classes.countdownLabel }, t('feedbackMeet.comingHome')))),
        React.createElement("div", { id: 'main-feedback-page', className: `${classes.mainFeedbackContainer} ${isSubmited ? 'submited' : ''}` },
            React.createElement(Image, { alt: 'feedback', src: BANNER_FEEDBACK, className: clsx(classes.bannerFeedback) }),
            React.createElement("div", null,
                !isSubmited &&
                    React.createElement(React.Fragment, null,
                        React.createElement("p", { className: cx(classes.mainTitle) }, t('feedbackMeet.leftMeeting')),
                        React.createElement("div", { className: cx(classes.boxActions) },
                            isShowFeedback === MEETING_STATUS.LEAVE &&
                                React.createElement(Button, { id: 'rejoin-btn', variant: 'outlined', onClick: () => window.location.reload() }, t('feedbackMeet.actions.rejoin')),
                            (isOwnerCaption && isShowFeedback === MEETING_STATUS.END && !browser?.isElectron()) ? React.createElement(Button, { onClick: handleDetailCaption }, t('feedbackMeet.summary')) : React.createElement(Button, { id: 'comehome-btn', onClick: handleTimeFish }, t('feedbackMeet.actions.comeHome')))),
                !isSubmited && React.createElement("div", { id: 'feedback-user', className: cx(classes.feedbackUser) },
                    React.createElement(DialogContent, { className: classes.dialogContent },
                        React.createElement(DialogContentText, { sx: { width: { xs: '100% !important', md: '400px !important' } } },
                            React.createElement("p", { className: 'title-feedback' }, t("feedbackMeet.title")),
                            React.createElement("div", { id: 'box-reactions', className: 'box-reactions' },
                                React.createElement(RenderRating, { rateValueNew: rateValueNew, onRateChange: handleChangeRateValue })),
                            React.createElement("div", { style: { width: '100%', height: '1px', borderTop: '1px dashed #B5B4B4' } }),
                            React.createElement("p", { className: cx(classes.feedbackLabel) }, t("feedbackMeet.label", { appName: interfaceConfig.APP_NAME || "Viettel Meeting" })),
                            React.createElement("textarea", { placeholder: t("feedbackMeet.placeholder"), value: feedbackValue, onChange: (e) => setFeedbackValue(e.target.value), rows: 3, onFocus: (e) => setIsEdited(true), className: classes.feedbackContent }))),
                    !isSubmited && React.createElement(DialogActions, { sx: { justifyContent: 'end', padding: '20px 0 0 0' } },
                        React.createElement(Button, { disabled: !rateValueNew, onClick: handleActions }, t('feedbackMeet.actions.submit'))))))));
};
export default FeedbackPage;
